exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-file-card__container{background-color:#fff;border-radius:4px;overflow:hidden;min-height:186px}.input-file-card__image-icon{width:105px}.input-file-card__image-preview-container{max-height:186px}.input-file-card__image-preview{border-radius:4px;height:100%;max-width:100%;max-height:inherit}.input-file-card__top-preview{padding:20px}.input-file-card__bottom-preview{padding:0 20px 20px}.input-file-card__button{text-transform:uppercase}.input-file-card__footnote{display:-ms-flexbox;display:flex;-ms-flex-line-pack:center;align-content:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;text-align:center;color:#adadad;width:105px}.input-file-card__footnote--is-error{color:#ff2e1e}.input-file-card__footnote,.input-file-card__icon-container{margin-left:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Input/InputFileCard/InputFileCard.scss
// module id = 730
// module chunks = 0 1 2 3